import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { CurrencyformatByCurrencyCodePipe } from '@fitness-force/pipes/currency';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';

@Component({
  selector: 'currency-by-code',
  templateUrl: './currency-by-code.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CurrencyformatByCurrencyCodePipe, AsyncPipe],
})
export class CurrencyByCodeComponent implements OnInit {
  private readonly cd = inject(ChangeDetectorRef);

  /** Full row object — injected by the grid as BehaviorSubject */
  columnData: Observable<any> = new BehaviorSubject(null);

  /** The key name for the amount field — injected by the grid as BehaviorSubject */
  keyName: Observable<any> = new BehaviorSubject(null);

  /**
   * Additional data injected via additionData / aData.
   * Expected shape: { currencyCodeKey: 'amount_currency' }
   */
  additionData: Observable<any> = new BehaviorSubject(null);

  vm$ = new BehaviorSubject<{ amount: number; currencyCode: string } | null>(null);

  ngOnInit(): void {
    // Wire up after the grid has replaced the property references via setInput / direct assignment
    combineLatest([this.columnData, this.keyName, this.additionData]).pipe(
      map(([row, amountKey, extra]) => {
        if (!row || !amountKey) return null;
        const amount: number = row[amountKey] ?? 0;
        const currencyCodeKey: string = extra?.currencyCodeKey ?? 'amount_currency';
        const currencyCode: string = row[currencyCodeKey] ?? '';
        return { amount, currencyCode };
      }),
    ).subscribe(value => {
      this.vm$.next(value);
      this.cd.markForCheck();
    });
  }
}
